module.exports = __webpack_public_path__ + "img/Monte_Kope_74.a3d7234a.jpg";